var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.346874 8.1806C0.126561 8.39154 -8.14086e-07 8.68685 -7.87039e-07 8.99622C-7.59993e-07 9.3056 0.126561 9.59622 0.346874 9.81185L8.59687 17.6868C9.04687 18.1181 9.75938 18.0993 10.1859 17.6493C10.6125 17.1993 10.5984 16.4868 10.1484 16.0603L3.93281 10.1212L19.875 10.1212C20.4984 10.1212 21 9.61966 21 8.99622C21 8.37278 20.4984 7.87122 19.875 7.87122L3.93281 7.87122L10.1531 1.93685C10.6031 1.5056 10.6172 0.797784 10.1906 0.347784C9.76406 -0.102216 9.05156 -0.116278 8.60156 0.310285L0.351562 8.18529L0.346874 8.1806Z",
    fill: "#11304D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPrev);
export default __webpack_public_path__ + "static/media/arrow-prev.1bff7a6822064b32e6e382c0f897d649.svg";
export { ForwardRef as ReactComponent };